<template>
  <div id="boardDataView">
    <div class="common_view_wrap">
      <div class="tit">{{subject}}</div>
      <div class="content">
        <viewer ref="editor"/>
      </div>
      <div class="files" v-if="files.length > 0">
        <div class="common_form_item col-6 type_file">
          <div class="common_form_label">첨부파일</div>
          <div class="common_form_input type_file" v-if="file1 != null && file1.length > 0">
            <div>
              <div>첨부파일 #1</div>
              <div>
                <template v-if="file1Origin != null && file1Origin.length > 0">{{file1Origin}}</template>
                <template v-else>첨부파일 없음</template>
              </div>
            </div>
            <label class="btn_download" @click="downloadFile('/upload/data/' + file1)">다운로드</label>
          </div>
          <div class="common_form_input type_file" v-if="file2 != null && file2.length > 0">
            <div>
              <div>첨부파일 #2</div>
              <div>
                <template v-if="file2Origin != null && file2Origin.length > 0">{{file2Origin}}</template>
                <template v-else>첨부파일 없음</template>
              </div>
            </div>
            <label class="btn_download" @click="downloadFile('/upload/data/' + file2)">다운로드</label>
          </div>
          <div class="common_form_input type_file" v-if="file3 != null && file3.length > 0">
            <div>
              <div>첨부파일 #3</div>
              <div>
                <template v-if="file3Origin != null && file3Origin.length > 0">{{file3Origin}}</template>
                <template v-else>첨부파일 없음</template>
              </div>
            </div>
            <label class="btn_download" @click="downloadFile('/upload/data/' + file3)">다운로드</label>
          </div>
          <div class="common_form_input type_file" v-if="file4 != null && file4.length > 0">
            <div>
              <div>첨부파일 #4</div>
              <div>
                <template v-if="file4Origin != null && file4Origin.length > 0">{{file4Origin}}</template>
                <template v-else>첨부파일 없음</template>
              </div>
            </div>
            <label class="btn_download" @click="downloadFile('/upload/data/' + file4)">다운로드</label>
          </div>
          <div class="common_form_input type_file" v-if="file5 != null && file5.length > 0">
            <div>
              <div>첨부파일 #5</div>
              <div>
                <template v-if="file5Origin != null && file5Origin.length > 0">{{file5Origin}}</template>
                <template v-else>첨부파일 없음</template>
              </div>
            </div>
            <label class="btn_download" @click="downloadFile('/upload/data/' + file5)">다운로드</label>
          </div>
        </div>
      </div>
    </div>
    <div class="common_bottom_wrap">
      <div class="btn_grey" @click="moveList">목록</div>
      <template v-if="this.mySession != null && this.mySession.userPid != null && this.mySession.userRole != null">
        <div class="btn_blue" @click="editBoardData">수정</div>
        <div class="btn_orange" @click="delBoardData">삭제</div>
      </template>
    </div>
  </div>
</template>

<script>
import common from '../../script/common'
import {Viewer} from '@toast-ui/vue-editor'
import boardData from '../../script/boardData'

export default {
  components: {
    viewer: Viewer
  },
  data () {
    return {
      // Common
      mySession: {},
      // Search
      searchParams: {},
      // Data
      originData: {},
      dataPid: null,
      subject: '',
      content: '',
      files: '',
      file1Origin: '',
      file1: '',
      file2Origin: '',
      file2: '',
      file3Origin: '',
      file3: '',
      file4Origin: '',
      file4: '',
      file5Origin: '',
      file5: ''
    }
  },
  mounted () {
    common.getSession(response => {
      if (response.data.resultCode === 1 && response.data.result != null && response.data.result.userPid != null && response.data.result.userRole != null) {
        this.mySession = response.data.result
      }
    })
    if (this.$route.params != null) {
      if (this.$route.params.searchParams != null) {
        this.searchParams = this.$route.params.searchParams
      }
      if (this.$route.params.data != null && this.$route.params.data.dataPid != null) {
        this.setBoardData(this.$route.params.data)
      }
    }
  },
  methods: {
    setBoardData (data) {
      console.log(data)
      this.originData = data
      this.dataPid = data.dataPid
      this.subject = data.subject
      if (data.content != null) {
        this.$refs.editor.invoke('setMarkdown', data.content)
      }
      this.files = data.files
      for (let i = 0; i < this.files.length; i++) {
        this[`file${i + 1}Origin`] = common.getOriginalFileName(this.files[i].fileName)
        this[`file${i + 1}`] = this.files[i].fileName
      }
    },
    downloadFile (url) {
      common.fileDownload(url)
    },
    moveList () {
      this.$router.push({
        name: 'BoardDataList',
        params: {
          searchParams: this.searchParams
        }
      })
    },
    editBoardData () {
      this.$router.push({
        name: 'BoardDataForm',
        params: {
          searchParams: this.searchParams,
          data: this.originData
        }
      })
    },
    delBoardData () {
      if (confirm('정말 삭제하시겠습니다?')) {
        boardData.boardData('delete', {
          dataPid: this.originData.dataPid
        }, response => {
          console.log('자료실 삭제', response)
          if (response.data.resultCode === 1) {
            common.amsAlert('general', '자료실을 삭제했습니다.')
            this.moveList()
          } else {
            common.amsAlert('retry', '자료실을 삭제하지 못했습니다.')
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.mobile_wrap #boardDataView {
  padding: 0 16px;
  box-sizing: border-box;
}

#boardDataView .content {
  padding: 25px 0;
  border-top: 3px solid #000000;
  border-bottom: 1px solid #000000;
  margin-top: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/boardData/View.vue